import { EBulkOperationStatus } from '@modules/items/types/bulkOperation.types';

import {
  EAiRunFeedbackReason,
  EAiRunFeedbackSentiment,
  type TAiCitationResponse,
  type TAiModeRequest,
  type TAiRunFeedbackInput,
  type TAiAssistantOrigin,
} from '../types';

export { EAiRunFeedbackSentiment as EGroundedQaFeedbackSentiment, EAiRunFeedbackReason as EGroundedQaFeedbackReason };

export enum EGroundedQaResultType {
  ANSWER = 'ANSWER',
  OUT_OF_SCOPE = 'OUT_OF_SCOPE',
  NO_ANSWER_FOUND = 'NO_ANSWER_FOUND',
}

export type TGroundedQaInput = {
  prompt: string;
  origin?: TAiAssistantOrigin;
};

export type TGroundedQaRequest = TGroundedQaInput & TAiModeRequest;
export type TGroundedQaCitationLocatorResponse = {
  chunkId: string;
  elementId?: string;
  elementIds: string[];
  quote?: string;
};

export type TGroundedQaResult = {
  answer: string;
  citationConfidence: number;
  citationSources: TAiCitationResponse[];
};

export type TGroundedQaFeedbackInput = TAiRunFeedbackInput;

export type TGroundedQaRunResponse = {
  runId: string;
  status: EBulkOperationStatus;
  resultType?: EGroundedQaResultType;
  result?: TGroundedQaResult;
  errorMessage?: string;
  progressMessage?: string;
  input: TGroundedQaInput;
  createdDate: string;
  completedDate?: string;
};
